export default __webpack_public_path__ + "static/media/permission.19b97f1a.svg";